/**
 * KnownObjectsIcon — A face in a viewfinder: the agent that finds known objects. Hugeicons face-id
 * (MIT).
 */

import svg from './svg/known-objects.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const KnownObjectsIcon = makeSvgIcon('known-objects', svg);
